import {Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {SearchService} from "../services/search.service";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchIDsCriteriaDto} from "../../../models/search-ids-criteria-dto";
import {saveAs} from "file-saver";
import {UserService} from "../../users/services/users.service";
import {StPagination2Component} from "../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../models/page-change-dto";
import {Auth2Service} from "../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-search-nonprofits-page',
  templateUrl: './search-nonprofits-page.component.html',
  styleUrls: ['./search-nonprofits-page.component.scss'],
  standalone: false
})
export class SearchNonprofitsPageComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Nonprofits'}
  ];

  pageName: string = 'Search Nonprofits';
  isSideNavOpened: boolean = false;
  platform: string = '';
  loadingIcon: boolean = false;

  errorMessages: any[] = [];

  successMessages: any[] = [];

  savedSearchArray: any[] = [];
  currentSavedSearchDto: any = null;
  searchTypeNameMap: any = {};

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  emailCodeVerifiedFlag: string = 'N';
  subscriptionActive: boolean = false;
  pilotTrialVerified: boolean = false;
  customerTrialVerified: boolean = false;

  rows: any[] = [];

  names: string[] = [];
  namesWithout: string[] = [];
  eins: string[] = [];
  includeTaxExemptRevoked: boolean = true;
  minYearsInBusiness: number = 0;
  zipCodes: string[] = [];
  states: string[] = [];
  cities: string[] = [];
  citiesWithout: string[] = [];
  counties: string[] = [];
  countiesWithout: string[] = [];
  affiliationCodeIds: number[] = [];
  deductabilityCodeIds: number[] = [];
  eoClassificationCodes: string[] = [];
  eoSubsectionCodes: string[] = [];
  filingReqCodeIds: number[] = [];
  pfFilingReqCodeIds: number[] = [];
  foundationCodeIds: number[] = [];
  nteeCodeIds: number[] = [];
  nteeParentCodeIds: number[] = [];
  organizationCodeIds: number[] = [];
  returnTypeCodeIds: number[] = [];
  totalAssetsRange: number[] = [];// will always be just one if selected but the end result is 2 (a min and a max)
  totalIncomeRange: number[] = [];
  keyStaff: string[] = [];// will always be just one
  causes: string[] = [];
  causeGivingInterestsList: string[] = [];
  causeGivingInterestsWithoutList: string[] = [];

  //statesCheckboxes: any[] = [];
  statesList: any[] = [];
  citiesCheckboxes: any[] = [];
  affiliationCodeCheckboxes: any[] = [];
  affiliationCodeButton: boolean = false;

  deductabilityCodeCheckboxes: any[] = [];
  deductabilityCodeButton: boolean = false;

  eoSubsectionClassificationCodeCheckboxes: any[] = [];
  eoSubsectionClassificationCodeButton: boolean = false;

  filingReqCodeCheckboxes: any[] = [];
  filingReqCodeButton: boolean = false;

  pfFilingReqCodeCheckboxes: any[] = [];
  pfFilingReqCodeButton: boolean = false;

  foundationCodeCheckboxes: any[] = [];
  foundationCodeButton: boolean = false;

  nteeCodeCheckboxes: any[] = [];
  nteeCodeButton: boolean = false;

  nteeParentCodeCheckboxes: any[] = [];
  nteeParentCodeButton: boolean = false;

  organizationCodeCheckboxes: any[] = [];
  organizationCodeButton: boolean = false;

  returnTypeCodeCheckboxes: any[] = [];
  returnTypeCodeButton: boolean = false;

  totalIncomeRadioButtons: any[] = [];
  totalIncomeButton: any = false;

  advancedFiltersButton: boolean = false;

  savedSearchModal: any = null;
  savedSearchOpenModalBtn1: HTMLElement | null = null;
  savedSearchOpenModalBtn2: HTMLElement | null = null;
  savedSearchCloseSpan: HTMLElement | null = null;

  companyNameAscRadioButton: boolean = false;
  companyNameDescRadioButton: boolean = false;
  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  totalAssetsAscRadioButton: boolean = false;
  totalAssetsDescRadioButton: boolean = false;

  sortedAscCompanyNameHeaderButton: boolean = false;
  sortedAscCityHeaderButton: boolean = false;
  sortedAscStateHeaderButton: boolean = false;
  sortedAscTotalAssetsHeaderButton: boolean = false;

  sortByCompanyNameAscId: number = 0;
  sortByCityAscId: number = 0;
  sortByStateAscId: number = 0;
  sortByTotalAssetsAscId: number = 0;

  citiesAutocomplete: any[] = [];
  companyNamesAutocomplete: any[] = [];

  causeDropdownList: any[] = [];
  causeGivingInterestsObj: any = {};
  causeGivingInterestsDropdownList: any[] = [];
  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  @ViewChild('nonprofitspaginator') stPaginator2Component!: StPagination2Component;
  page: number = 1;
  pageSize: number = 100;
  collectionSize: number = 0;
  customPageSizes = [
    {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }, {
      "pageSizeId" : 500,
      "pageSize": 500
    }
  ];
  showSideNavErrorMessages: boolean = false;
  sideNavErrorMessages: any[] = [];
  showSideNavSuccessMessages: boolean = false;
  sideNavSuccessMessages: any[] = [];
  //Needs pop up for Nonprofit Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private searchService: SearchService,
              private routerChild: Router, private route: ActivatedRoute, private userService: UserService,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Search Nonprofits")
  }

  ngOnInit(): void {
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag()
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      this.userService.getSubscriptionVerification(this.username).subscribe(
        (verificationResult: any) => {
          this.subscriptionActive = verificationResult.body.verified;
          this.pilotTrialVerified = verificationResult.body.pilotTrialVerified;
          this.customerTrialVerified = verificationResult.body.customerTrialVerified;

          //Begin initializing page
          this.populateFilters();
          this.loadSearchTypeNameMap();
          const delayedSetup = () => {
            this.setUpSavedSearchModal();
            const lastSearchJsonString = localStorage.getItem('lastSearchNonprofit');
            if (lastSearchJsonString) {
              // @ts-ignore
              const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
              this.loadNonprofitLastSearchParams(lastSearchFilter);
            }
          }
          setTimeout(delayedSetup, 4000);
          this.platform = navigator.userAgent;
          if (this.platform) {
            this.platform = this.platform.toLowerCase();
          }
        }, (error:HttpErrorResponse) => {
          this.redirectToLogin(error);
          this.pageErrorMessages.push({
            field: 'Subscription Error',
            detail: 'This feature is not available for inactive subscriptions. Please activate your subscription.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    }
  }
  showSideNavErrorMessagesToUser(): void {
    this.showSideNavErrorMessages = true;
    const counterFn = () => {
      this.showSideNavErrorMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  showSideNavSuccessMessagesToUser(): void {
    this.showSideNavSuccessMessages = true;
    const counterFn = () => {
      this.showSideNavSuccessMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  getSavedSearches(): void {
    this.userService.getAllSavedSearches(this.username, 'NONPROFIT_SEARCH', this.impersonatedEmail)
      .subscribe(
        (result: any) => {
          if (result && result.body) {
            this.savedSearchArray = result.body;
          }
        }, (err: HttpErrorResponse) => {
          this.pageErrorMessages.push({
            field: 'Saved Search API Error',
            detail: 'Failed to pull the saved searches...',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      )
  }

  populateNonprofitsCities(): void {
    // @ts-ignore
    let nonprofitCitiesCacheExpTimeStr: string = localStorage.getItem('nonprofitCitiesCacheExpTime');
    if (!nonprofitCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('nonprofitCitiesCache');
    } else {
      let lastSearchNonprofitExpTime: number = parseInt(nonprofitCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= lastSearchNonprofitExpTime) {
        //expire the cached search
        localStorage.removeItem('nonprofitCitiesCache');
      }
    }
    const nonprofitCitiesCacheJsonString = localStorage.getItem('nonprofitCitiesCache');
    if (!nonprofitCitiesCacheJsonString) {
      this.searchService.getNonprofitsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('nonprofitCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('nonprofitCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Nonprofits Error',
          detail: 'Failed to pull Nonprofit cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
    } else {
      this.citiesAutocomplete = JSON.parse(nonprofitCitiesCacheJsonString);
    }
  }

  populateNonprofitsCompanyNames(): void {
    this.companyNamesAutocomplete = [];
    this.searchService.getNonprofitsCompanyNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.companyNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Nonprofit company names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }
  populateFilters(): void {
    this.populateUSAStates();
    this.populateNonprofitsCities();
    this.populateNonprofitsCompanyNames();
    //this.populateAffiliationCodeCheckboxes();
    //this.populateDeductabilityCodeCheckboxes();
    //this.populateEoClassificationSubsectionCodeCheckboxes();
    this.populateFoundationCodeCheckboxes();
    this.populateFilingReqCodeCheckboxes();
    this.populatePfFilingReqCodeCheckboxes();
    this.populateNteeCodeCheckboxes();
    this.populateNteeParentCodeCheckboxes();
    this.populateOrganizationCodeCheckboxes();
    this.populateReturnTypeCodeCheckboxes();
    this.populateCauseCategories()

    this.populateResultsFromLastSearch();
    this.getSavedSearches();
    this.setUpSavedSearchModal();
  }

  populateCauseCategories(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body;
        this.populateCauseGivingInterestsDropdown();
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Causes Drop down',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  openSavedSearchModal(): boolean {
    this.closeNav();
    // @ts-ignore
    this.savedSearchModal.style.display = "block";
    return true;
  }
  closeSavedSearchModal(): boolean {
    // @ts-ignore
    this.savedSearchModal.style.display = "none";
    return true;
  }

  setUpSavedSearchModal(): void {
    // Get the modal
    this.savedSearchModal = document.getElementById("saved-search-modal-id");

    // Get the button that opens the modal
    // @ts-ignore
    this.savedSearchOpenModalBtn1 = document.getElementById("saved-search-modal-button1-id");
    this.savedSearchOpenModalBtn2 = document.getElementById("saved-search-modal-button2-id");
    // Get the <span> element that closes the modal
    this.savedSearchCloseSpan = document.getElementsByClassName("close")[0] as HTMLElement;
  }

  populateResultsFromLastSearch(newSort: boolean = false): void {
    // @ts-ignore
    let lastSearchNonprofitExpTimeStr: string = localStorage.getItem('lastSearchNonprofitExpTime');
    if (!lastSearchNonprofitExpTimeStr) {
      lastSearchNonprofitExpTimeStr = '0';
      //expire the cached search
      localStorage.removeItem('lastSearchNonprofit');
    } else {
      let lastSearchNonprofitExpTime: number = parseInt(lastSearchNonprofitExpTimeStr);
      let now = Date.now();
      if (now >= lastSearchNonprofitExpTime) {
        //expire the cached search
        localStorage.removeItem('lastSearchNonprofit');
      }
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchNonprofit');
    if (lastSearchJsonString) {
      // @ts-ignore
      const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
      if (newSort) {
        this.page = 1;
        this.sortByCompanyNameAscId = 0;
        if (this.companyNameAscRadioButton) {
          this.sortByCompanyNameAscId = 1;
        } else if (this.companyNameDescRadioButton) {
          this.sortByCompanyNameAscId = 2;
        }

        this.sortByCityAscId = 0;
        if (this.cityAscRadioButton) {
          this.sortByCityAscId = 1;
        } else if (this.cityDescRadioButton) {
          this.sortByCityAscId = 2;
        }

        this.sortByStateAscId = 0;
        if (this.stateAscRadioButton) {
          this.sortByStateAscId = 1;
        } else if (this.stateDescRadioButton) {
          this.sortByStateAscId = 2;
        }

        this.sortByTotalAssetsAscId = 0;
        if (this.totalAssetsAscRadioButton) {
          this.sortByTotalAssetsAscId = 1;
        } else if (this.totalAssetsDescRadioButton) {
          this.sortByTotalAssetsAscId = 2;
        }
        lastSearchFilter['sortByCompanyNameAsc'] = this.sortByCompanyNameAscId;
        lastSearchFilter['sortByCityAsc'] = this.sortByCityAscId;
        lastSearchFilter['sortByStateAsc'] = this.sortByStateAscId;
        lastSearchFilter['sortByTotalAssetsAsc'] = this.sortByTotalAssetsAscId
      }
      localStorage.setItem('lastSearchNonprofit', JSON.stringify(lastSearchFilter));
      //this.loadNonprofitLastSearchParams(lastSearchFilter)
      // @ts-ignore
      this.executeSearchPages(lastSearchFilter, this.page, this.pageSize, this.username);
    }
  }
  loadNonprofitLastSearchParams(nonprofitSearchJson: any): void {
    if (nonprofitSearchJson['names'] && nonprofitSearchJson['names'].length > 0) {
      const namesEl = document.getElementById('name-with-text-id');
      // @ts-ignore
      namesEl.value = nonprofitSearchJson['names'].join(',');
    }
    if (nonprofitSearchJson['namesWithout'] && nonprofitSearchJson['namesWithout'].length > 0) {
      const namesWithoutEl = document.getElementById('name-without-text-id');
      // @ts-ignore
      namesWithoutEl.value = nonprofitSearchJson['namesWithout'].join(',');
    }

    if (nonprofitSearchJson['eins'] && nonprofitSearchJson['eins'].length > 0) {
      const einsEl = document.getElementById('ein-text-id');
      // @ts-ignore
      einsEl.value = nonprofitSearchJson['eins'].join(',');
    }
    if (nonprofitSearchJson['states'] && nonprofitSearchJson['states'].length > 0) {
      const usaStatesEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      usaStatesEl.value = nonprofitSearchJson['states'][0];
    }
    if (nonprofitSearchJson['cities'] && nonprofitSearchJson['cities'].length > 0) {
      const citiesEl = document.getElementById('cities-text-id');
      // @ts-ignore
      citiesEl.value = nonprofitSearchJson['cities'].join(',');
    }
    if (nonprofitSearchJson['citiesWithout'] && nonprofitSearchJson['citiesWithout'].length > 0) {
      const citiesWithoutEl = document.getElementById('cities-without-text-id');
      // @ts-ignore
      citiesWithoutEl.value = nonprofitSearchJson['citiesWithout'].join(',');
    }
    if (nonprofitSearchJson['zipCodes'] && nonprofitSearchJson['zipCodes'].length > 0) {
      const zipCodesEl = document.getElementById('zip-code-text-id');
      // @ts-ignore
      zipCodesEl.value = nonprofitSearchJson['zipCodes'][0];
    }
    /*
    if (nonprofitSearchJson['counties'] && nonprofitSearchJson['counties'].length > 0) {
      this.donor_countiesInput = nonprofitSearchJson['counties'][0];
    }
    if (nonprofitSearchJson['countiesWithout'] && nonprofitSearchJson['countiesWithout'].length > 0) {
      this.donor_countiesWithoutInput = nonprofitSearchJson['countiesWithout'][0];
    }*/

    if (nonprofitSearchJson['nteeCodeIds'] && nonprofitSearchJson['nteeCodeIds'].length > 0) {
      for (const nteeCodeId of nonprofitSearchJson['nteeCodeIds']) {
        let i: number = 0;
        let nteeCodeLength: number = this.nteeCodeCheckboxes.length;
        while (i < nteeCodeLength) {

          if (this.nteeCodeCheckboxes[i].nteeCodeId === nteeCodeId) {
            this.nteeCodeCheckboxes[i].checked = true;
            this.nteeCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (nonprofitSearchJson['nteeParentCodeIds'] && nonprofitSearchJson['nteeParentCodeIds'].length > 0) {
      for (const nteeParentCodeId of nonprofitSearchJson['nteeParentCodeIds']) {
        let i: number = 0;
        let affCodeLength: number = this.nteeParentCodeCheckboxes.length;
        while (i < affCodeLength) {
          if (this.nteeParentCodeCheckboxes[i].nteeParentCodeId === nteeParentCodeId) {
            this.nteeParentCodeCheckboxes[i].checked = true;
            this.nteeParentCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (nonprofitSearchJson['organizationCodeIds'] && nonprofitSearchJson['organizationCodeIds'].length > 0) {
      for (const organizationCodeId of nonprofitSearchJson['organizationCodeIds']) {
        let i: number = 0;
        let affCodeLength: number = this.organizationCodeCheckboxes.length;
        while (i < affCodeLength) {
          if (this.organizationCodeCheckboxes[i].organizationCodeId === organizationCodeId) {
            this.organizationCodeCheckboxes[i].checked = true;
            this.organizationCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    this.causeGivingInterestsList = [];
    if (nonprofitSearchJson['causeGivingInterests'] && nonprofitSearchJson['causeGivingInterests'].length > 0) {
      for (const causeGivingInterest of nonprofitSearchJson['causeGivingInterests']) {
        this.causeGivingInterestsList.push(causeGivingInterest);
      }
    }

    this.causeGivingInterestsWithoutList = [];
    /*
    if (nonprofitSearchJson['causeGivingInterestsWithout'] && nonprofitSearchJson['causeGivingInterestsWithout'].length > 0) {
      for (const causeGivingInterest of nonprofitSearchJson['causeGivingInterestsWithout']) {
        this.causeGivingInterestsWithoutList.push(causeGivingInterest);
      }
    }*/

    if (nonprofitSearchJson['sortByCompanyNameAsc']) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      if (nonprofitSearchJson['sortByCompanyNameAsc'] == 1) {
        this.companyNameAscRadioButton = true;
      } else if (nonprofitSearchJson['sortByCompanyNameAsc'] == 2) {
        this.companyNameDescRadioButton = true;
      }
    }

    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    if (nonprofitSearchJson['sortByCityAsc']) {
      if (nonprofitSearchJson['sortByCityAsc'] == 1) {
        this.cityAscRadioButton = true;
      } else if (nonprofitSearchJson['sortByCityAsc'] == 2) {
        this.cityDescRadioButton = true;
      }
    }

    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    if (nonprofitSearchJson['sortByStateAsc']) {
      if (nonprofitSearchJson['sortByStateAsc'] == 1) {
        this.stateAscRadioButton = true;
      } else if (nonprofitSearchJson['sortByStateAsc'] == 2) {
        this.stateDescRadioButton = true;
      }
    }

    this.totalAssetsAscRadioButton = false;
    this.totalAssetsDescRadioButton = false;
    if (nonprofitSearchJson['sortByTotalAssetsAsc']) {
      if (nonprofitSearchJson['sortByTotalAssetsAsc'] == 1) {
        this.totalAssetsAscRadioButton = true;
      } else if (nonprofitSearchJson['sortByTotalAssetsAsc'] == 2) {
        this.totalAssetsDescRadioButton = true;
      }
    }
  }

  onApplySavedSearch(): void {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    let savedSearchEl = document.getElementById('saved-search-selector-id');
    // @ts-ignore
    let savedSearchId: number = savedSearchEl.value;
    let i: number = 0;
    let foundFlag: boolean = false;
    for (const savedSearchObj of this.savedSearchArray) {
      if (savedSearchObj.savedSearchId == savedSearchId) {
        foundFlag = true;
        break;
      }
      i = i + 1;
    }
    if (!foundFlag) {
      this.sideNavErrorMessages.push({
        field: 'Saved Search Error',
        detail: 'Please enter a saved search.....',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return;
    }
    localStorage.setItem('lastSearchDonor', this.savedSearchArray[i].savedSearchJson);
    this.executeSearchPages(JSON.parse(this.savedSearchArray[i].savedSearchJson), this.page,
      this.pageSize, this.username);
  }

  executeSearchPages(filter: any, page: number, pageSize: number, username: string): void {
    this.closeNav();
    this.loadingIcon = true;
    this.searchService.getNonprofitsPages(filter, page, pageSize, username).subscribe((result: any) => {
      if (result && result.body) {
        //populate table with results
        this.collectionSize = result.body.collectionSize;
        this.page = result.body.page;
        this.pageSize = result.body.pageSize;
        this.rows = result.body.dtos;
        this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
      }
      this.loadingIcon = false;
    }, (err: HttpErrorResponse) => {
      this.redirectToLogin(err);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Nonprofits page. Please try again.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.loadingIcon = false;
    });
  }

  resetAllFiltersModal(): boolean {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.names = [];
    const nameEl = document.getElementById('name-with-text-id');
    // @ts-ignore
    nameEl.value = '';

    this.namesWithout = [];
    //const nameWithoutEl = document.getElementById('name-without-text-id');
    // @ts-ignore
    //nameWithoutEl.value = '';

    this.eins = [];
    const einsEl = document.getElementById('ein-text-id');
    // @ts-ignore
    einsEl.value = '';

    this.states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStatesEl.value = '';

    this.cities = [];
    const cityEl = document.getElementById('cities-text-id');
    // @ts-ignore
    cityEl.value = '';

    this.citiesWithout = [];
    /*
    const cityWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    cityWithoutEl.value = '';*/

    this.zipCodes = [];
    const zipCodesEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    zipCodesEl.value = '';

    this.minYearsInBusiness = 0;
    //const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    // @ts-ignore
    //minYearsInBusinessEl.value = '';
    this.includeTaxExemptRevoked = true;

    this.affiliationCodeIds = [];
    for (const affiliationCodeCheckboxTemp of this.affiliationCodeCheckboxes) {
      affiliationCodeCheckboxTemp.checked = false;
    }

    this.deductabilityCodeIds = [];
    for (const deductabilityCodeCheckboxTemp of this.deductabilityCodeCheckboxes) {
      deductabilityCodeCheckboxTemp.checked = false;
    }

    this.eoClassificationCodes = [];
    this.eoSubsectionCodes = [];

    this.filingReqCodeIds = [];
    for (const filingReqCodeCheckboxTemp of this.filingReqCodeCheckboxes) {
      filingReqCodeCheckboxTemp.checked = false;
    }

    this.foundationCodeIds = [];
    for (const foundationCodeCheckboxTemp of this.foundationCodeCheckboxes) {
      foundationCodeCheckboxTemp.checked = false;
    }

    this.nteeCodeIds = [];
    for (const nteeCodeCheckboxTemp of this.nteeCodeCheckboxes) {
      nteeCodeCheckboxTemp.checked = false;
    }

    this.nteeParentCodeIds = [];
    for (const nteeParentCodeCheckboxTemp of this.nteeParentCodeCheckboxes) {
      nteeParentCodeCheckboxTemp.checked = false;
    }

    this.organizationCodeIds = [];
    for (const organizationCodeCheckboxTemp of this.organizationCodeCheckboxes) {
      organizationCodeCheckboxTemp.checked = false;
    }

    this.totalIncomeRange = [];
    for (const totalIncomeRadioButtonTemp of this.totalIncomeRadioButtons) {
      totalIncomeRadioButtonTemp.checked = false;
    }

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';

    this.causeGivingInterestsList = [];
    this.causeGivingInterestsWithoutList = [];
    return true;
  }

  clearResultsAndFilter(): boolean {
    this.resetAllFiltersModal();
    this.collectionSize = 0;
    this.page = 1;
    this.rows = [];
    this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
    localStorage.removeItem('lastSearchNonprofit');
    localStorage.removeItem('lastSearchNonprofitExpTime');
    return true;
  }
  changePageResults(pageChangeDto: PageChangeDto): void {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.pageSize = pageChangeDto["pageSize"]
    }
    // @ts-ignore
    let filter: string = localStorage.getItem('lastSearchNonprofit');
    const lastSearchFilter: any = JSON.parse(filter);
    this.loadingIcon = true;

    this.searchService.getNonprofitsPages(lastSearchFilter, updatePageValue, this.pageSize, this.username)
      .subscribe((result : any) => {
        let limitCode = result.headers.get('limitCode');
        let featureExportLimitRows = result.headers.get('featureExportLimitRows');
        let featureExportCurrentRows = result.headers.get('featureExportCurrentRows');
        let featureExportFutureRows = result.headers.get('featureExportFutureRows');
        if (result && result.body) {
          this.rows = result.body.dtos;
          this.page = updatePageValue
          this.collectionSize = result.body.collectionSize
        }
        this.loadingIcon = false;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Search Nonprofits Error',
          detail: 'Failed to pull Nonprofits page. Please try again.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.loadingIcon = false;
      })
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.searchService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull USA States. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  toggleAffiliationCodesFilter(): void {
    this.affiliationCodeButton = !this.affiliationCodeButton;
  }

  toggleRevokeLogicalExpression(): void {
    this.includeTaxExemptRevoked = !this.includeTaxExemptRevoked;
  }

  addValToAffiliationCodes(idValue:number): void {
    const affiliationCodeEl = document.getElementById('flexCheckCheckedAffiliationCode-' + idValue);
    // @ts-ignore
    const affiliationCodeChecked = affiliationCodeEl.checked;
    this.affiliationCodeCheckboxes[idValue]['checked'] = affiliationCodeChecked;
  }

  populateAffiliationCodeCheckboxes(): void {
    this.searchService.getAffiliationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.affiliationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Affiliation Codes.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  toggleDeductabilityCodesFilter(): void {
    this.deductabilityCodeButton = !this.deductabilityCodeButton;
  }

  addValToDeductabilityCodes(idValue:number): void {
    const deductabilityCodeEl = document.getElementById('flexCheckCheckedDeductabilityCode-' + idValue);
    // @ts-ignore
    const deductabilityCodeChecked = deductabilityCodeEl.checked;
    this.deductabilityCodeCheckboxes[idValue]['checked'] = deductabilityCodeChecked;
  }
  populateDeductabilityCodeCheckboxes(): void {
    this.searchService.getDeductibilityCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.deductabilityCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Deductability Codes.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleEoSubsectionClassificationCodesFilter(): void {
    this.eoSubsectionClassificationCodeButton = !this.eoSubsectionClassificationCodeButton;
  }

  addValToEoClassificationSubsectionCodes(idValue:number): void {
    const eoSubsectionClassificationCodeEl = document.getElementById('flexCheckCheckedEoSubsectionClassificationCode-' + idValue);
    // @ts-ignore
    const eoSubsectionClassificationCodeChecked = eoSubsectionClassificationCodeEl.checked;
    this.eoSubsectionClassificationCodeCheckboxes[idValue]['checked'] = eoSubsectionClassificationCodeChecked;
  }

  populateEoClassificationSubsectionCodeCheckboxes(): void {
    this.searchService.getEOSubsectionClassificationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.eoSubsectionClassificationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
    });
  }

  populateEoSubsectionCodeCheckboxes(): void {

  }

  toggleFilingReqCodesFilter(): void {
    this.filingReqCodeButton = !this.filingReqCodeButton;
  }

  addValToFilingReqCodes(idValue:number): void {
    const filingReqCodeEl = document.getElementById('flexCheckCheckedFilingReqCode-' + idValue);
    // @ts-ignore
    const filingReqCodeChecked = filingReqCodeEl.checked;
    this.filingReqCodeCheckboxes[idValue]['checked'] = filingReqCodeChecked;
  }
  populateFilingReqCodeCheckboxes(): void {
    this.searchService.getFilingReqCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.filingReqCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Filing Requirement Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  populatePfFilingReqCodeCheckboxes(): void {
    this.pfFilingReqCodeCheckboxes = [];
  }

  toggleFoundationCodesFilter(): void {
    this.foundationCodeButton = !this.foundationCodeButton;
  }

  addValToFoundationCodes(idValue:number): void {
    const foundationCodeEl = document.getElementById('flexCheckCheckedFoundationCode-' + idValue);
    // @ts-ignore
    const foundationCodeChecked = foundationCodeEl.checked;
    this.foundationCodeCheckboxes[idValue]['checked'] = foundationCodeChecked;
  }

  populateFoundationCodeCheckboxes(): void {
    this.searchService.getFoundationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.foundationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Foundation Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleAdvancedFilters(): any {
    this.advancedFiltersButton = !this.advancedFiltersButton;
  }
  toggleNteeCodesFilter(): void {
    this.nteeCodeButton = !this.nteeCodeButton;
  }
  addValToNteeCodes(idValue:number): void {
    const nteeCodeEl = document.getElementById('flexCheckCheckedNteeCode-' + idValue);
    // @ts-ignore
    const nteeCodeChecked = nteeCodeEl.checked;
    this.nteeCodeCheckboxes[idValue]['checked'] = nteeCodeChecked;
  }

  populateNteeCodeCheckboxes(): void {
    this.searchService.getNteeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nteeCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull NTEE Codes. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }


  toggleNteeParentCodesFilter(): void {
    this.nteeParentCodeButton = !this.nteeParentCodeButton;
  }
  addValToNteeParentCodes(idValue:number): void {
    const nteeParentCodeEl = document.getElementById('flexCheckCheckedNteeParentCode-' + idValue);
    // @ts-ignore
    const nteeParentCodeChecked = nteeParentCodeEl.checked;
    this.nteeParentCodeCheckboxes[idValue]['checked'] = nteeParentCodeChecked;
  }

  populateNteeParentCodeCheckboxes(): void {
    this.searchService.getNteeParentCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nteeParentCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull NTEE Parent Codes. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleOrganizationCodesFilter(): void {
    this.organizationCodeButton = !this.organizationCodeButton;
  }
  addValToOrganizationCodes(idValue:number): void {
    const organizationCodeEl = document.getElementById('flexCheckCheckedOrganizationCode-' + idValue);
    // @ts-ignore
    const organizationCodeChecked = organizationCodeEl.checked;
    this.organizationCodeCheckboxes[idValue]['checked'] = organizationCodeChecked;
  }

  populateOrganizationCodeCheckboxes(): void {
    this.searchService.getOrganizationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.organizationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Organization Codes. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleReturnTypeCodesFilter(): void {
    this.returnTypeCodeButton = !this.returnTypeCodeButton;
  }

  addValToReturnTypeCodes(idValue:number): void {
    const returnTypeCodeEl = document.getElementById('flexCheckCheckedReturnTypeCode-' + idValue);
    // @ts-ignore
    const returnTypeCodeChecked = returnTypeCodeEl.checked;
    this.returnTypeCodeCheckboxes[idValue]['checked'] = returnTypeCodeChecked;
  }

  populateReturnTypeCodeCheckboxes(): void {
    const browserUrl: string = window.location.href;
    this.searchService.getReturnTypeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.returnTypeCodeCheckboxes = result.body;
        if (browserUrl.includes('nonprofits')) {
          for ( const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
            if (returnTypeCodeCheckboxTemp['returnTypeCodeName'] !== '990PF') {
              returnTypeCodeCheckboxTemp['checked'] = true;
            } else {
              returnTypeCodeCheckboxTemp['checked'] = false;
            }
          }
        } else if (browserUrl.includes('donors')) {
          for ( const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
            if (returnTypeCodeCheckboxTemp['returnTypeCodeName'] === '990PF') {
              returnTypeCodeCheckboxTemp['checked'] = true;
            } else {
              returnTypeCodeCheckboxTemp['checked'] = false;
            }
          }
        } else {
          //should never happen
        }
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Return Type Codes. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });

  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
        }
        return;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Search Type API failure',
          detail: 'Failed to pull the Search Type Names.',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
        return;
      });
    return;
  }

  onSearch(searchToBeSaved: boolean): any {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.showPageErrorMessages = false;
    this.showPageSuccessMessages = false;
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.names = [];
    const namesEl = document.getElementById('name-with-text-id');
    // @ts-ignore
    const namesSelected = namesEl.value;
    if (namesSelected) {
      let cleanNames: string = this.apiService.trimLeadingTrailingSpaces(namesSelected);
      let namesFinal: string[] = cleanNames.split(",");
      if (namesFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Nonprofit Names limit exceeded. You are limited to 10 names.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < namesFinal.length; i = i + 1) {
        this.names.push(this.apiService.trimLeadingTrailingSpaces(namesFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.namesWithout = [];
    /*
    const nameWithoutEl = document.getElementById('name-without-text-id');
    // @ts-ignore
    const nameWithoutSelected = nameWithoutEl.value;
    console.log('nameWithoutSelected: ' + JSON.stringify(nameWithoutSelected));
    if (nameWithoutSelected) {
      this.namesWithout.push(nameWithoutSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.eins = [];
    const einsEl = document.getElementById('ein-text-id');
    // @ts-ignore
    const einsSelected = einsEl.value;
    if (einsSelected) {
      this.eins.push(this.apiService.trimLeadingTrailingSpaces(einsSelected));
      nonEmptyFilterFlag = true;
    }

    this.states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStatesSelected = usaStatesEl.value;
    if (usaStatesSelected) {
      this.states.push(usaStatesSelected);
      nonEmptyFilterFlag = true;
    }

    this.cities = [];
    const citiesEl = document.getElementById('cities-text-id');
    // @ts-ignore
    const citiesSelected = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string = this.apiService.trimLeadingTrailingSpaces(citiesSelected)
      let citiesTemp : string[] = cleanCities.split(',');
      if (citiesTemp.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (const cityTemp of citiesTemp) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(cityTemp)
        if (finalCity && !finalCity.startsWith(':')) {
          this.cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.citiesWithout = [];
    /*
    const cityWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = cityWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string = this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected)
      let citiesWithoutTemp : string[] = cleanCitiesWithout.split(',');
      if (citiesWithoutTemp.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (const cityWithoutTemp of citiesWithoutTemp) {
        this.citiesWithout.push(this.apiService.trimLeadingTrailingSpaces(cityWithoutTemp));
      }
      nonEmptyFilterFlag = true;
    }*/

    this.zipCodes = [];
    const zipCodesEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    const zipCodesSelected = zipCodesEl.value;
    if (zipCodesSelected) {
      this.zipCodes.push(zipCodesSelected);
      nonEmptyFilterFlag = true;
    }
    this.minYearsInBusiness = 0;
    /*
    const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    if (minYearsInBusinessEl) {
      if (this.minYearsInBusiness > 0) {
        // @ts-ignore
        this.minYearsInBusiness = parseInt(minYearsInBusinessEl.value);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.includeTaxExemptRevoked = true;
    const includeTaxExemptRevokedEl = document.getElementById('flexRadioIncludeRevocationList');
    if (includeTaxExemptRevokedEl) {
      // @ts-ignore
      this.includeTaxExemptRevoked = includeTaxExemptRevokedEl.checked;
      nonEmptyFilterFlag = true;
    }

    this.counties = [];
    /*
    const countyEl = document.getElementById('county-text-id');
    // @ts-ignore
    const countySelected = countyEl.value;
    console.log('countySelected: ' + JSON.stringify(countySelected));
    if (countySelected) {
      this.counties.push(countySelected);
      nonEmptyFilterFlag = true;
    }*/

    this.countiesWithout = [];
    /*
    const countyWithoutEl = document.getElementById('county-without-text-id');
    // @ts-ignore
    const countyWithoutSelected = countyWithoutEl.value;
    console.log('countyWithoutSelected: ' + JSON.stringify(countyWithoutSelected));
    if (countyWithoutSelected) {
      this.countiesWithout.push(countyWithoutSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.affiliationCodeIds = [];
    /*
    for (const affiliationCodeCheckboxTemp of this.affiliationCodeCheckboxes) {
      if (affiliationCodeCheckboxTemp.checked === true) {
        this.affiliationCodeIds.push(affiliationCodeCheckboxTemp.affiliationCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.deductabilityCodeIds = [];
    /*
    for (const deductabilityCodeCheckboxTemp of this.deductabilityCodeCheckboxes) {
      if (deductabilityCodeCheckboxTemp.checked === true) {
        this.deductabilityCodeIds.push(deductabilityCodeCheckboxTemp.deductabilityCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.eoClassificationCodes = [];
    this.eoSubsectionCodes = [];

    this.filingReqCodeIds = [];
    /*
    for (const filingReqCodeCheckboxTemp of this.filingReqCodeCheckboxes) {
      if (filingReqCodeCheckboxTemp.checked === true) {
        this.filingReqCodeIds.push(filingReqCodeCheckboxTemp.filingReqCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.foundationCodeIds = [];
    /*
    for (const foundationCodeCheckboxTemp of this.foundationCodeCheckboxes) {
      if (foundationCodeCheckboxTemp.checked === true) {
        this.foundationCodeIds.push(foundationCodeCheckboxTemp.foundationCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nteeCodeIds = [];

    for (const nteeCodeCheckboxTemp of this.nteeCodeCheckboxes) {
      if (nteeCodeCheckboxTemp.checked === true) {
        this.nteeCodeIds.push(nteeCodeCheckboxTemp.nteeCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nteeParentCodeIds = [];

    for (const nteeParentCodeCheckboxTemp of this.nteeParentCodeCheckboxes) {
      if (nteeParentCodeCheckboxTemp.checked === true) {
        this.nteeParentCodeIds.push(nteeParentCodeCheckboxTemp.nteeParentCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.organizationCodeIds = [];

    for (const organizationCodeCheckboxTemp of this.organizationCodeCheckboxes) {
      if (organizationCodeCheckboxTemp.checked === true) {
        this.organizationCodeIds.push(organizationCodeCheckboxTemp.organizationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.returnTypeCodeIds = [];
    for (const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
      if (returnTypeCodeCheckboxTemp.checked === true) {
        this.returnTypeCodeIds.push(returnTypeCodeCheckboxTemp.returnTypeCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    if (this.names.length == 0 && this.eins.length == 0 && this.states.length == 0 && this.cities.length == 0 &&
      this.zipCodes.length == 0 && this.affiliationCodeIds.length == 0 && this.deductabilityCodeIds.length == 0 &&
      this.eoClassificationCodes.length == 0 && this.eoSubsectionCodes.length == 0 && this.filingReqCodeIds.length == 0 &&
      this.pfFilingReqCodeIds.length == 0 && this.foundationCodeIds.length == 0 && this.nteeCodeIds.length == 0 &&
      this.nteeParentCodeIds.length == 0 && this.organizationCodeIds.length == 0 && this.totalAssetsRange.length == 0 &&
      this.causeGivingInterestsList.length == 0 && this.keyStaff.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }

    this.page = 1;
    this.pageSize = 100;

    this.sortByCompanyNameAscId = 0;
    if (this.companyNameAscRadioButton) {
      this.sortByCompanyNameAscId = 1;
    } else if (this.companyNameDescRadioButton) {
      this.sortByCompanyNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByTotalAssetsAscId = 0;
    if (this.totalAssetsAscRadioButton) {
      this.sortByTotalAssetsAscId = 1;
    } else if (this.totalAssetsDescRadioButton) {
      this.sortByTotalAssetsAscId = 2;
    }

    const filter: SearchIDsCriteriaDto = {
      'names': this.names,
      'namesWithout': this.namesWithout,
      'eins': this.eins,
      'states': this.states,
      'cities': this.cities,
      'citiesWithout': this.citiesWithout,
      'zipCodes': this.zipCodes,
      'includeTaxExemptRevoked': this.includeTaxExemptRevoked,
      'minYearsInBusiness': this.minYearsInBusiness,
      'donatedGrantsCities': [],
      'donatedGrantsStates': [],
      'taxYear': 0,
      'counties': this.counties,
      'countiesWithout': this.countiesWithout,
      'affiliationCodeIds': this.affiliationCodeIds,
      'deductibilityCodeIds': this.deductabilityCodeIds,
      'eoClassificationCodes': this.eoClassificationCodes,
      'eoSubsectionCodes': this.eoSubsectionCodes,
      'filingReqCodeIds': this.filingReqCodeIds,
      'pfFilingReqCodeIds': this.pfFilingReqCodeIds,
      'foundationCodeIds': this.foundationCodeIds,
      'nteeCodeIds': this.nteeCodeIds,
      'nteeParentCodeIds': this.nteeParentCodeIds,
      'organizationCodeIds': this.organizationCodeIds,
      'returnTypeCodeIds': this.returnTypeCodeIds,
      'causes': [],
      'totalAssetsRange': this.totalAssetsRange,
      'totalIncomeRange': this.totalIncomeRange,
      'keyStaff': this.keyStaff,
      'causeGivingInterests': this.causeGivingInterestsList,
      'causeGivingInterestsWithout': this.causeGivingInterestsWithoutList,
      'sortByCompanyNameAsc': this.sortByCompanyNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByTotalAssetsAsc': this.sortByTotalAssetsAscId
    }

    if (!nonEmptyFilterFlag) {
      this.sideNavErrorMessages.push({
        field: 'Filter Error',
        detail: 'Please submit a non empty filter.',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return false;
    }
    //Expire 2 hours from now
    let expirationTimestamp: number = Date.now() + 1000*3600*2;
    localStorage.setItem('lastSearchNonprofit', JSON.stringify(filter));
    localStorage.setItem('lastSearchNonprofitExpTime', expirationTimestamp.toString());
    this.page = 1;// all new searches default to the first page
    this.pageSize = 100;//default
    const pageDropdownEl = document.getElementById('search-nonprofits-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }
    //Submit to API
    // @ts-ignore
    const username: string = localStorage.getItem('username');
    if (searchToBeSaved) {
      const savedSearchNameEl = document.getElementById('saved-search-name-text-id');
      // @ts-ignore
      const savedSearchName = savedSearchNameEl.value;
      this.saveSearchToDatabase(JSON.stringify(filter), username, savedSearchName);
    } else {
      // @ts-ignore
      this.executeSearchPages(filter, this.page, this.pageSize, username);
    }
    return true;
  }
  saveSearchToDatabase(filter: any, username: string, savedSearchName: string) {
    const savedSearchDto: any = {
      savedSearchId: -1,
      userId: -1,
      savedSearchName: savedSearchName,
      searchTypeDto: {
        searchTypeId: this.searchTypeNameMap['NONPROFIT_SEARCH'],
        searchTypeName: 'NONPROFIT_SEARCH'
      },
      savedSearchJson: filter,
      createdTS: new Date(),
      updatedTS: new Date()
    }

    this.userService.editSavedSearch(savedSearchDto, username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.currentSavedSearchDto = result.body;
          this.getSavedSearches();
          this.successMessages.push({
            field: 'Nonprofit Saved Search Successful',
            detail: 'Successfully updated the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'success'
          });
          this.showSuccessMessagesToUser();
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.errorMessages.push({
          field: 'Nonprofit Saved Search API Failure',
          detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      }
    );
  }

  onExportToExcel(): any {
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    if (this.customerTrialVerified) {
      this.pageErrorMessages.push({
        field: 'Cannot Export to CSV',
        detail: 'You are in customer trial mode. You can only export to CSV with a paid subscription.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser(16000);
      return
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchNonprofit');
    // @ts-ignore
    const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
    const username = localStorage.getItem('username');
    this.pageSize = 100;//default
    const pageDropdownEl = document.getElementById('search-nonprofits-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }
    // @ts-ignore
    this.searchService.getNonprofitsPagesForExcel(lastSearchFilter, this.page, this.pageSize, username).subscribe(
      (result: any) => {
        let limitCode = result.headers.get('limitCode');
        let featureExportLimitRows = result.headers.get('featureExportLimitRows');
        let featureExportCurrentRows = result.headers.get('featureExportCurrentRows');
        let featureExportFutureRows = result.headers.get('featureExportFutureRows');
        if (result && result.body) {
          if (limitCode == "2") {
            this.pageErrorMessages.push({
              field: 'Nonprofits Download Failure',
              detail: 'Woah-woah! Our Search Nonprofits tool is meant for online use. You are already at your Weekly limit of 10 downloads.' +
                ' If you need bulk download, please email us to temporarily bump up your limit.',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser(60000);
          } else if (limitCode == "1") {
            this.pageErrorMessages.push({
              field: 'Nonprofits Download Failure',
              detail: 'Woah-woah! Our Search Nonprofits tool is meant for online use. You are already at your Daily limit of 2 downloads.' +
                ' If you need bulk download, please email us to temporarily bump up your limit.',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser(60000);
          } else {
            this.pageSuccessMessages.push({
              field: 'Nonprofits Export Successful',
              detail: 'Nonprofits successfully exported to csv...',
              severity: 'success'
            });
            let fileName: string = 'nonprofit_search_table.csv';
            saveAs(result.body, fileName);
            this.showPageSuccessMessagesToUser(16000);
          }
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        if (this.customerTrialVerified) {
          this.pageErrorMessages.push({
            field: 'Cannot Export to CSV',
            detail: 'You are in customer trial mode. You can only export to CSV with paid subscription.',
            severity: 'error'
          });
        } else {
          this.pageErrorMessages.push({
            field: 'Export Nonprofits Error',
            detail: 'Failed to export the nonprofits to csv.',
            severity: 'error'
          });
        }
        this.showPageErrorMessagesToUser();
      });
    return true;
  }

  toggle(): boolean {
    if (!this.isSideNavOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
    return true;
  }
  openNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "70%"
      // @ts-ignore
      element.style['padding-left'] = "20px";
      this.isSideNavOpened = true;
    }
  }

  /* Set the width of the side navigation to 0 */
  closeNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "0";
      // @ts-ignore
      element.style['padding-left'] = "0px";
      this.isSideNavOpened = false;
    }
  }

  toggleCompanyNameAscButton(): void {
    this.companyNameAscRadioButton = !this.companyNameAscRadioButton;

    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
    }
  }

  toggleCompanyNameDescButton(): void {
    this.companyNameDescRadioButton = !this.companyNameDescRadioButton;
    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleTotalAssetsAscButton(): void {
    this.totalAssetsAscRadioButton = !this.totalAssetsAscRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
  }

  toggleTotalAssetsDescButton(): void {
    this.totalAssetsDescRadioButton = !this.totalAssetsDescRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    }
  }

  sortTextCompanyName(): void {
    if (!this.sortedAscCompanyNameHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscCompanyNameHeaderButton = !this.sortedAscCompanyNameHeaderButton
    this.populateResultsFromLastSearch(true);
  }

  sortTextCity(): void {
    if (!this.sortedAscCityHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscCityHeaderButton = !this.sortedAscCityHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortTextState(): void {
    if (!this.sortedAscCityHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscCityHeaderButton = !this.sortedAscCityHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortNumberTotalAssets(): void {
    if (!this.sortedAscTotalAssetsHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscTotalAssetsHeaderButton = !this.sortedAscTotalAssetsHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }

  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("OR");
      } else {
        this.causeGivingInterestsList.push("OR");
      }
    }
    this.causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if ('ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' == causeGivingInterestSelected) {
        return;
      }
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.causeGivingInterestsList.indexOf(row);
    const size = this.causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.causeGivingInterestsWithoutList.indexOf(row);
    const size = this.causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeGivingInterestsObj = result.body;
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL']
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Causes Giving Interests Drop down',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.causeGivingInterestsObj[causeCategorySelVal]) {
        //this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.causeGivingInterestsObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL'];
      }
    }
    return true;
  }

  formatZip(inputStr: string): string{
    return this.apiService.formatZipCode(inputStr)
  }
  formatEin(inputStr: string): string{
    return this.apiService.formatEin(inputStr)
  }

  onViewDetails(row: any) {
    const browserUrl = window.location.href;
    if (browserUrl.includes('donors')) {
      //For Donors
      this.routerChild.navigateByUrl(row.nonprofitDonorId ? `/app/search/donors/${row.nonprofitDonorId}/details` : 'home');
    } else {
      //Nonprofits
      this.routerChild.navigateByUrl(row.nonprofitDonorId ? `/app/search/nonprofits/${row.nonprofitDonorId}/details` : 'home');
    }
  }
}
